module.exports = __webpack_public_path__ + "static/media/stats_bg.d6f3c731.jpg";